import * as tslib_1 from "tslib";
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import { sizeClassName, alignmentClassName, textWrapClassName, normalizeUrl, Context, } from 'wix-rich-content-common';
var AtomicBlock = /** @class */ (function (_super) {
    tslib_1.__extends(AtomicBlock, _super);
    function AtomicBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AtomicBlock.prototype.renderComponent = function (Component, children, props) {
        return React.createElement(Component, tslib_1.__assign({}, props), children);
    };
    AtomicBlock.prototype.render = function () {
        var _a;
        var _b = this.props, type = _b.type, typeMap = _b.typeMap, componentData = _b.componentData, children = _b.children, styles = _b.styles;
        var _c = this.context, theme = _c.theme, isMobile = _c.isMobile, anchorTarget = _c.anchorTarget, relValue = _c.relValue, config = _c.config;
        var _d = typeMap[type], Component = _d.component, elementType = _d.elementType;
        var classNameStrategies = typeMap[type].classNameStrategies || {};
        var size = classNameStrategies.size, alignment = classNameStrategies.alignment, textWrap = classNameStrategies.textWrap, container = classNameStrategies.container;
        var settings = (config && config[type]) || {};
        if (Component) {
            Component.contextType = Context.type;
            if (elementType !== 'inline') {
                var hasLink = componentData.config && componentData.config.link;
                var ContainerElement = !hasLink ? 'div' : 'a';
                var containerClassNames = classNames(styles.pluginContainerReadOnly, (_a = {},
                    _a[styles.pluginContainerMobile] = isMobile,
                    _a[styles.anchor] = hasLink,
                    _a[theme.anchor] = hasLink && theme.anchor,
                    _a), isFunction(alignment)
                    ? alignment(componentData, theme, styles, isMobile)
                    : alignmentClassName(componentData, theme, styles, isMobile), isFunction(size)
                    ? size(componentData, theme, styles, isMobile)
                    : sizeClassName(componentData, theme, styles, isMobile), isFunction(textWrap)
                    ? textWrap(componentData, theme, styles, isMobile)
                    : textWrapClassName(componentData, theme, styles, isMobile));
                var containerProps = {};
                if (hasLink) {
                    var _e = componentData.config.link, url = _e.url, target = _e.target, rel = _e.rel;
                    containerProps = {
                        href: normalizeUrl(url),
                        target: target || anchorTarget || '_self',
                        rel: rel || relValue || 'noopener',
                    };
                }
                return (React.createElement("div", { className: styles.atomic },
                    React.createElement(ContainerElement, tslib_1.__assign({ className: containerClassNames }, containerProps), isFunction(container) ? (React.createElement("div", { className: container(theme) }, this.renderComponent(Component, children, {
                        componentData: componentData,
                        settings: settings,
                        key: this.props.innerKey,
                    }))) : (this.renderComponent(Component, children, {
                        componentData: componentData,
                        settings: settings,
                        key: this.props.innerKey,
                    })))));
            }
            else {
                return this.renderComponent(Component, children, {
                    componentData: componentData,
                    settings: settings,
                    key: this.props.innerKey,
                });
            }
        }
        return null;
    };
    return AtomicBlock;
}(PureComponent));
AtomicBlock.contextType = Context.type;
// return a list of types with a function that wraps the viewer
var getPluginsViewer = function (typeMap, pluginProps, styles) {
    var res = {};
    Object.keys(typeMap).forEach(function (type) {
        res[type] = function (children, entity, _a) {
            var key = _a.key;
            return (React.createElement(AtomicBlock, tslib_1.__assign({ typeMap: typeMap, type: type, key: "atomic-" + key, componentData: entity }, pluginProps, { styles: styles, innerKey: "inner-" + key }), children));
        };
    });
    return res;
};
export default getPluginsViewer;
//# sourceMappingURL=PluginsViewer.js.map